module.exports = __webpack_public_path__ + "img/yuanbao.56a18b95.png";